import { cityCountrySchema } from "../schemas/cityCountry";
import cityCountryJson from "./cityCountry.json";
import { z } from "astro/zod";

export const getCityCountry = () =>
  z.array(cityCountrySchema).parse(cityCountryJson);
